import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { LoginModalService, AccountService, Account } from 'app/core';
import { EventManager } from 'app/shared/services';
import { RunningAccountsComponent } from 'app/entities/FDERunningService/running-accounts/running-account.component';

@Component({
    selector: 'app-running',
    standalone: true,
    imports: [CommonModule, RunningAccountsComponent],
    templateUrl: './running.component.html',
    styleUrls: ['running.css']})
export class RunningComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;

    constructor(
        private accountService: AccountService,
        private loginModalService: LoginModalService,
        private eventManager: EventManager
    ) {}

    ngOnInit() {
        this.accountService.identity().then((account: Account) => {
            this.account = account;
        });
        this.registerAuthenticationSuccess();
    }

    registerAuthenticationSuccess() {
        this.eventManager.subscribe('authenticationSuccess', message => {
            this.accountService.identity().then(account => {
                this.account = account;
            });
        });
    }

    isAuthenticated() {
        return this.accountService.isAuthenticated();
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }
}
